import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
// import * as userActions from 'app/auth/store/actions';
// import * as Actions from 'app/store/actions';
// import firebaseService from 'app/services/firebaseService';
// import auth0Service from 'app/services/auth0Service';
// import jwtService from '../jwtService';

class Auth extends Component {
    state = {
        waitAuthCheck: true,
        noToken: true
    };

    componentWillMount() {
        const token = window.localStorage.getItem('sf_jwt_access_token');
        const { history } = this.props;
        if (!token) {
            this.setState({ noToken: false });
            history.push('/auth/login');
        } else {
            // history.push('/dashboard');
            this.setState({ noToken: false });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        console.log(prevState.noToken, this.state.noToken);
    }

    // componentWillUpdate(nextProps) {
    //     if (!nextProps.isAuthenticated) {
    //         this.props.history.push('/');
    //     }
    // }

    // componentDidMount() {
    //     console.log(this.props);
    //     const token = window.localStorage.getItem('fs_jwt_access_token');
    //     if (token) {
    //         this.setState({ noToken: false });
    //     } else {
    //         this.setState({ noToken: true });
    //     }
    //     // return Promise.all([
    //     //     // this.jwtCheck()
    //     // ]).then(() => {
    //     //     this.setState({ waitAuthCheck: false });
    //     // });
    // }

    // jwtCheck = () =>
    //     new Promise(resolve => {
    //         console.log('eiei', jwtService);
    //         // jwtService.on('onAutoLogin', () => {
    //         //     console.log({ message: 'Logging in with JWT' });
    //         //     /**
    //         //      * Sign in and retrieve user data from Api
    //         //      */
    //         //     jwtService
    //         //         .signInWithToken()
    //         //         .then(user => {
    //         //             this.props.setUserData(user);
    //         //             resolve();
    //         //             console.log({ message: 'Logged in with JWT' });
    //         //         })
    //         //         .catch(error => {
    //         //             console.log({ message: error });
    //         //             resolve();
    //         //         });
    //         // });
    //         //         jwtService.on('onAutoLogout', message => {
    //         //             if (message) {
    //         //                 console.log({ message });
    //         //             }
    //         //             this.props.logout();
    //         //             resolve();
    //         //         });
    //         //         jwtService.on('onNoAccessToken', () => {
    //         //             resolve();
    //         //         });
    //         jwtService.init();
    //         return Promise.resolve();
    //     });

    render() {
        const { noToken } = this.state;
        // const { history } = this.props;

        return noToken ? (
            <React.Fragment>Loading...</React.Fragment>
        ) : (
            <React.Fragment children={this.props.children} />
        );
        // return <React.Fragment children={this.props.children} />;
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            // logout: userActions.logoutUser,
            // setUserData: userActions.setUserData
        },
        dispatch
    );
}

export default withRouter(
    connect(
        null,
        mapDispatchToProps
    )(Auth)
);
